module.exports = __webpack_public_path__ + "static/media/SJE091_03.fd87b676.jpg";